import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Strong = styled.span({
  lineHeight: '36px',
  color: fontStyles.colors.primary,
  fontWeight: 'bold',
  [mobileMediaQuery]: {
    lineHeight: '24px',
  },
});
